const Loader = ({ fullScreen = false, centered = false }) => {
  if (centered) {
    return (
      <div className="absolute inset-0 bg-white/40 z-50 flex items-center justify-center">
        <div className="loader7 text-[#3F80F7]">
          <div className="inner-ring"></div>
        </div>
      </div>
    );
  }

  return (
    <div className={fullScreen ? "loader7-container" : "loader7-container-modular"}>
      <div className="loader7 text-[#3F80F7]">
        <div className="inner-ring"></div>
      </div>
    </div>
  );
};

export default Loader;
